import React from 'react';
import { useIntl } from 'react-intl';
import { NoResultsForKeywordText as NoResultsForKeywordTextStyled } from './NoResultsForKeywordText.styles';
import { NoResultsForKeywordTextProps } from 'models/NoResultsForKeywordTextProps';

const NoResultsForKeywordText = ({
  internationalSearch,
  categoryListPresent
}: NoResultsForKeywordTextProps) => {
  const { formatMessage } = useIntl();

  if (internationalSearch) {
    return (
      <NoResultsForKeywordTextStyled internationalSearch={true}>
        {formatMessage({
          id: 'RESULT_LIST.NO_RESULTS.INTERNATIONAL_SEARCH.FOR_KEYWORD'
        })}
        &nbsp;
        {formatMessage({
          id: 'RESULT_LIST.NO_RESULTS.INTERNATIONAL_SEARCH.FIND_MORE'
        })}
      </NoResultsForKeywordTextStyled>
    );
  }

  return (
    <NoResultsForKeywordTextStyled>
      {formatMessage({ id: 'RESULT_LIST.NO_RESULTS.FOR_KEYWORD' })}
      {categoryListPresent &&
        ' ' +
          formatMessage({ id: 'RESULT_LIST.NO_RESULTS.SEARCH_IN_CATEGORIES' })}
    </NoResultsForKeywordTextStyled>
  );
};

export default NoResultsForKeywordText;
